import { AppsPermissions, inventoryModule } from '../DashboardModule/modulepermissions';

export const chefPermissionForInventory = [
  AppsPermissions['web-dash-visible'],
  inventoryModule['inventory-visible'],
  inventoryModule['ingredients-visible'],
  inventoryModule['ingredients-create'],
  inventoryModule['ingredients-read'],
  inventoryModule['ingredients-edit'],
  inventoryModule['ingredients-delete'],
  inventoryModule['invoices-visible'],
  inventoryModule['invoices-create'],
  inventoryModule['invoices-read'],
  inventoryModule['invoices-edit'],
  inventoryModule['invoices-delete'],
  inventoryModule['non-ingredients-visible'],
  inventoryModule['non-ingredients-create'],
  inventoryModule['non-ingredients-edit'],
  inventoryModule['non-ingredients-read'],
  inventoryModule['non-ingredients-delete'],
  inventoryModule['orders-visible'],
  inventoryModule['orders-create'],
  inventoryModule['orders-edit'],
  inventoryModule['orders-read'],
  inventoryModule['orders-delete'],
  inventoryModule['recipes-visible'],
  inventoryModule['recipes-create'],
  inventoryModule['recipes-edit'],
  inventoryModule['recipes-read'],
  inventoryModule['recipes-delete'],
  inventoryModule['storage-areas-visible'],
  inventoryModule['storage-areas-create'],
  inventoryModule['storage-areas-edit'],
  inventoryModule['storage-areas-read'],
  inventoryModule['storage-areas-delete'],
  inventoryModule['vendors-visible'],
  inventoryModule['vendors-create'],
  inventoryModule['vendors-edit'],
  inventoryModule['vendors-read'],
  inventoryModule['vendors-delete'],
];
